import { trackEvent } from 'utils';
import { CART_STEPS_CATEGORIES, CART_ACTIONS, CART_TRACKING_LABEL } from '../constants/analytics';

export function trackPhoneDescriptionClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.PHONE, CART_TRACKING_LABEL.click);
}

export function trackSubmitDone(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.NEXT, CART_TRACKING_LABEL.click);
}

export function trackSubmitFail(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.NEXT, CART_TRACKING_LABEL.error);
}

export function trackBackToOverviewClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.BACK, CART_TRACKING_LABEL.click);
}

export function trackDialogOpen(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.ADDRESS_VALIDATION, CART_TRACKING_LABEL.yes);
}

export function trackDialogClose(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.ADDRESS_VALIDATION, CART_TRACKING_LABEL.no);
}

export function trackSuggestionClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.ADDRESS_VALIDATION, CART_TRACKING_LABEL.suggestion);
}

export function trackOriginalClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.ADDRESS, CART_ACTIONS.ADDRESS_VALIDATION, CART_TRACKING_LABEL.input);
}
